<template>
  <div>
    <form class="py-3 mt-5" @submit.prevent="login">
      <div class="container mt-5">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="card bg-light">
              <div class="card-body">
                <h3 class="font-weight-light mb-3">Log in</h3>
                <section class="form-group">
                  <div class="col-12 alert alert-danger px-3" v-if="error">
                    {{error}}
                  </div>
                  <label class="form-control-label sr-only" for="Email">Email</label>
                  <input
                    required
                    class="form-control"
                    type="email"
                    id="email"
                    placeholder="Email"
                    v-model="email"
                  />
                </section>
                <section class="form-group">
                  <div class="input-group">
                    <input
                      required
                      class="form-control"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Password"
                      v-model="password"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        :aria-label="showPassword ? 'Verberg wachtwoord' : 'Toon wachtwoord'"
                        :aria-pressed="showPassword.toString()"
                        @click="showPassword = !showPassword"
                      >
                        <b-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
                      </button>
                    </div>
                  </div>
                </section>
                <div class="form-group text-right mb-0">
                  <button class="btn btn-primary" type="submit">Log in</button>
                </div>

                <!-- Divider -->
                <div class="d-flex align-items-center my-4">
                  <hr class="flex-grow-1">
                  <span class="px-3 text-muted">of</span>
                  <hr class="flex-grow-1">
                </div>

                <!-- Firebase UI container -->
                <div id="firebaseui-auth-container"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <p class="text-center mt-2">
      or
      <router-link to="/register">register</router-link>
      or
      <router-link to="/password-forget">forgot password</router-link>
    </p>
    
    <div class="version-info">
      v{{ version }}
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import db from "../db.js";
import { version } from "../../package.json";

export default {
  name: "login",
  data: function() {
    return {
      email: "",
      password: "",
      showPassword: false,
      error: "",
      version: version,
      ui: null
    }
  },
  methods: {
    handleUserAfterLogin: function(user, isAdmin) {
      let self = this
      self.$emit("showAdminUI", isAdmin)
      var userRef = db.collection('users').doc(user.uid);
      userRef.get().then(doc => {
        if (!doc.exists) {
          userRef.set({ sharedName: user.displayName }, { merge: true }).then(() => {
            userRef.collection('shoppingLists').doc('active').set({ items: [], recipes: [] }).then(() => {
              console.log("User document created")
              self.$emit("initUser", user)
            }).catch(error => {
              console.log("Error creating shopping list", error)
            })
          }).catch(error => {
            console.log("Error creating user: ", error);
          })
        } else {
          self.$emit("initUser", user)
        }
      }).catch(error => {
        console.log(error)
      })
    },

    login: function() {
      const info = {
        email: this.email,
        password: this.password
      }
      let self = this
      firebase.auth().signInWithEmailAndPassword(info.email, info.password)
        .then((userCredentials) => {
          var user = userCredentials.user
          user.getIdTokenResult(false).then(token => {
            if (user != null && (user.emailVerified || token.claims.admin)) {
              self.handleUserAfterLogin(user, Boolean(token.claims.admin))
            } else {
              self.error = "E-mail is niet gevalideert"
            }
          }).catch(error => {
            console.log(error)
          })
        }, error => {
          self.error = error.message;
        })
    },

    initFirebaseUI: function() {
      let self = this
      
      const uiConfig = {
        signInSuccessUrl: '/',
        signInOptions: [
          {
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            customParameters: {
              prompt: 'select_account'
            }
          }
        ],
        signInFlow: 'popup',
        callbacks: {
          signInSuccessWithAuthResult: function(authResult) {
            const user = authResult.user
            user.getIdTokenResult(false).then(token => {
              self.handleUserAfterLogin(user, Boolean(token.claims.admin))
            })
            return false // Don't redirect, we handle it ourselves
          },
          signInFailure: function(error) {
            console.log("FirebaseUI sign-in error:", error)
            self.error = error.message || "Inloggen mislukt"
          }
        }
      }

      // Check if UI instance exists, if so delete and recreate
      if (firebaseui.auth.AuthUI.getInstance()) {
        this.ui = firebaseui.auth.AuthUI.getInstance()
      } else {
        this.ui = new firebaseui.auth.AuthUI(firebase.auth())
      }
      
      this.ui.start('#firebaseui-auth-container', uiConfig)
    }
  },
  mounted: function() {
    this.initFirebaseUI()
  },
  beforeDestroy: function() {
    if (this.ui) {
      this.ui.delete()
    }
  }
}
</script>

<style scoped>
.version-info {
  position: fixed;
  bottom: 10px;
  right: 15px;
  font-size: 0.75rem;
  color: #999;
}
</style>

<style>
/* FirebaseUI styling overrides */
.firebaseui-container {
  max-width: 100% !important;
}
.firebaseui-card-content {
  padding: 0 !important;
}
.firebaseui-idp-button {
  max-width: 100% !important;
}
</style>
